module.exports = __webpack_public_path__ + "img/10_asia.155411f3.png";